export default "__VITE_ASSET__C3hW8vl6__"